/*
 * @Author: mayanxia 
 * @Date: 2022-05-07 08:43:16 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-06-16 15:53:26
 */

<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <detail-list :col="2" size="small">
        <detail-list-item :term="$t('设备编号')">{{model.meterId}}</detail-list-item>
        <detail-list-item :term="$t('SIM卡号')">{{model.meterSim}}</detail-list-item>
        <detail-list-item :term="$t('上传时间')">{{model.createTime}}</detail-list-item>
        <detail-list-item :term="$t('表端时间')">{{model.meterTime}}</detail-list-item>
        <detail-list-item :term="$t('表类型')">{{meterTypeName}}</detail-list-item>
        <detail-list-item :term="$t('阀门状态')">{{model.meterValveStatus==1?$t('关阀'):$t('开阀')}}</detail-list-item>
        <detail-list-item :term="$t('硬件版本号')">{{model.hardwareVersion}}</detail-list-item>
        <detail-list-item :term="$t('软件版本号')">{{model.softwareVersion}}</detail-list-item>
        <detail-list-item :term="$t('阀门开度')">{{model.valveOpening}}</detail-list-item>
        <detail-list-item :term="$t('电压值(V)')">{{model.meterBatteryVoltage}}</detail-list-item>
        <detail-list-item :term="$t('CSQ(信号指示)')">{{meterSignal.signalCsq}}</detail-list-item>
        <detail-list-item :term="$t('RSRP(信号强度)')">{{meterSignal.signalRsrp}}</detail-list-item>
        <detail-list-item :term="$t('RSRQ(信号质量)')">{{meterSignal.signalRsrq}}</detail-list-item>
        <detail-list-item :term="$t('SNR(信噪比)')">{{meterSignal.signalSnr}}</detail-list-item>
      </detail-list>
    </a-spin>
  </j-modal>
</template>

<script>

  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  export default {
    name: 'PartValveUpDataRecordModal',
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        width:800,
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/partValveUpDataRecord/add",
          edit: "/jeecg-charge/meter/partValveUpDataRecord/edit",
        },
        meterSignal: {}
      }
    },
    computed: {
      title() {
        return this.$t('详情')
      },
      meterTypeName() {
        if(this.model.meterType) {
          let meterType = parseInt(this.model.meterType).toString(16)
          return  filterDictTextByCache('valve_device_type',meterType);
        }
        
      }
    },
    created () {
    },
    methods: {
      close () {
        this.$emit('close');
        this.visible = false;
      },
      add () {
        this.edit({});
      },
      edit (record) {
        
        this.model = Object.assign({}, record);
        let meterSignalStrength = record.meterSignalStrength
        this.meterSignal = JSON.parse(meterSignalStrength)
        this.visible = true;
      },
      handleOk () {
        const that = this;
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>